<script lang="ts">
	import { page } from '$app/stores'
	import Button from '$lib/components/ui/button/button.svelte'
</script>

<div class="flex min-h-screen flex-col items-center justify-center p-4 text-center">
	<h1 class="mb-4 text-4xl font-bold text-gray-800 dark:text-gray-200">
		Oops! Something's not quite right... 😅
	</h1>
	<p class="text-lg text-gray-600 dark:text-gray-400">{$page?.error?.message}</p>
	<Button href="/" class="m-10">Take me home!</Button>
</div>
